import { render, staticRenderFns } from "./ClientCreate.vue?vue&type=template&id=628df74e&scoped=true&"
import script from "./ClientCreate.vue?vue&type=script&lang=js&"
export * from "./ClientCreate.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreate.vue?vue&type=style&index=0&id=628df74e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628df74e",
  null
  
)

export default component.exports